import { render } from "./RemainingVacationEdit.vue?vue&type=template&id=0ec2c9b7"
import script from "./RemainingVacationEdit.vue?vue&type=script&lang=js"
export * from "./RemainingVacationEdit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\ekk-hrm-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__